import TipoNotaForm from './tipo_notas/TipoNotaForm.vue';
import TipoNotaConversionForm from './tipo_notas/TipoNotaConversionForm.vue';

export default {
  install: (app, _options) => {
    app.component('CalificacionesTipoNotaForm', TipoNotaForm)
      .component('CalificacionesTipoNotaConversionForm', TipoNotaConversionForm);
  },
};
